(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9205],{

/***/ 53196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ PhoneIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var PhoneIcon = function(param) {
    var width = param.width, height = param.height, className = param.className;
    var _w = width || "24";
    var _h = height || "24";
    var _cn = className || "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: _w,
        height: _h,
        className: _cn,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2.67666 5.6124C3.30278 4.94223 4.32876 3.91779 5.17311 3.08517C5.95479 2.31437 7.21104 2.32945 7.9816 3.11136L9.939 5.09762C10.5194 5.68658 10.497 6.62193 9.96675 7.25642C8.35993 9.17912 8.65743 10.3794 11.2694 12.9913C13.8837 15.6056 15.0477 15.8652 16.9704 14.2504C17.6015 13.7204 18.5337 13.701 19.1207 14.2795L21.1397 16.2694C21.9221 17.0405 21.9366 18.2977 21.1649 19.0795C20.3341 19.9213 19.3124 20.9444 18.6399 21.5756C14.5763 25.3905 -1.12886 9.68566 2.67666 5.6124Z",
            stroke: "currentColor"
        })
    });
};


/***/ }),

/***/ 23303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30719);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81703);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58262);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29757);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13390);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88116);




// Import Swiper styles



// import required modules

var NewGallery = function(param) {
    var images = param.images;
    var items = (Array.isArray(images) ? images : []).map(function(param) {
        var url = param.url;
        return {
            original: url,
            thumbnail: url,
            originalAlt: "Product image",
            thumbnailAlt: "product thumbnail image"
        };
    });
    var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
                slidesPerView: 1,
                spaceBetween: 30,
                keyboard: {
                    enabled: true
                },
                scrollbar: {
                    enabled: true
                },
                pagination: {
                    clickable: true
                },
                // loop={true}
                navigation: false,
                onBeforeInit: function(swiper) {
                    swiperRef.current = swiper;
                },
                modules: [
                    swiper__WEBPACK_IMPORTED_MODULE_6__/* .EffectFade */ .xW,
                    swiper__WEBPACK_IMPORTED_MODULE_6__/* .Navigation */ .W_,
                    swiper__WEBPACK_IMPORTED_MODULE_6__/* .Scrollbar */ .LW
                ],
                className: "product-loop-swiper",
                id: "swiper",
                children: [
                    items.map(function(item, key) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                            className: "tw-bg-gray-50 md:tw-rounded-5 md:tw-border tw-border-gray-70 tw-border-opacity-50 tw-overflow-hidden tw-relative",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-w-full p-100p tw-relative",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .Image */ .E, {
                                    src: item.original,
                                    className: "!tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full",
                                    alt: item.originalAlt
                                })
                            })
                        }, "item-".concat(key));
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "custom-prev tw-w-6 tw-h-6 tw-rounded-full tw-absolute tw-top-1/2 tw-left-2 md:tw-left-3 tw--translate-y-1/2 tw-bg-white/[0.25] tw-text-black tw-flex tw-items-center tw-justify-center tw-z-10",
                        onClick: function() {
                            var ref;
                            return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .J, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_9__/* .ArrowLeftIcon */ .Y, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "custom-next tw-w-6 tw-h-6 tw-rounded-full tw-absolute tw-top-1/2 tw-right-2 md:tw-right-3 tw--translate-y-1/2 tw-bg-white/[0.25] tw-text-black tw-flex tw-items-center tw-justify-center tw-rotate-180 tw-z-10",
                        onClick: function() {
                            var ref;
                            return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .J, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_9__/* .ArrowLeftIcon */ .Y, {})
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NewGallery);


/***/ }),

/***/ 94069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isArticleNoindex; }
/* harmony export */ });
/* unused harmony export OFF_TOPIC_ARTICLE_IDS */
/**
 * Bài WordPress (anthu.today) LẠC ĐỀ — tin tức bất động sản, công nghệ, du lịch, xã hội…
 * không liên quan trang sức. Gắn noindex trên anthu.vn và bỏ khỏi sitemap để Google
 * đánh giá site chuyên về kim cương/trang sức.
 *
 * Danh sách lấy từ file SEO_anthu_can_chinh.xlsx (tab "1-Bài lạc đề"), quét ngày 26/09/2026.
 * Muốn GIỮ lại bài nào: xoá ID đó khỏi danh sách. Muốn ẩn thêm: thêm ID (xem ID trong
 * link sửa bài WordPress: post.php?post=<ID>).
 *
 * Ngoài danh sách này, bài nào tắt index trong Yoast cũng tự bị noindex (xem isArticleNoindex).
 */ var OFF_TOPIC_ARTICLE_IDS = new Set([
    78,
    89,
    136,
    141,
    151,
    156,
    176,
    193,
    200,
    204,
    208,
    214,
    219,
    224,
    228,
    233,
    237,
    242,
    246,
    250,
    254,
    258,
    266,
    273,
    276,
    281,
    286,
    294,
    298,
    301,
    305,
    312,
    315,
    318,
    321,
    325,
    330,
    334,
    343,
    346,
    349,
    352,
    355,
    359,
    362,
    365,
    369,
    372,
    375,
    384,
    387,
    390,
    393,
    397,
    401,
    405,
    408,
    411,
    414,
    417,
    420,
    424,
    430,
    435,
    438,
    441,
    444,
    452,
    455,
    458,
    461,
    464,
    468,
    471,
    474,
    477,
    490,
    493,
    496,
    499,
    502,
    505,
    508,
    511,
    514,
    517,
    520,
    523,
    526,
    532,
    537,
    542,
    550,
    553,
    556,
    560,
    564,
    567,
    570,
    577,
    581,
    584,
    592,
    595,
    598,
    608,
    614,
    617,
    620,
    623,
    631,
    637,
    643,
    647,
    653,
    656,
    662,
    666,
    676,
    679,
    686,
    689,
    692,
    695,
    698,
    701,
    708,
    711,
    714,
    717,
    723,
    726,
    729,
    732,
    735,
    738,
    741,
    744,
    747,
    750,
    755,
    758,
    763,
    766,
    769,
    772,
    775,
    778,
    781,
    790,
    793,
    796,
    799,
    802,
    805,
    808,
    811,
    814,
    822,
    825,
    831,
    835,
    839,
    842,
    845,
    848,
    851,
    854,
    857,
    860,
    863,
    866,
    869,
    872,
    875,
    878,
    881,
    884,
    887,
    891,
    894,
    897,
    900,
    906,
    909,
    912,
    915,
    918,
    921,
    924,
    927,
    930,
    933,
    936,
    941,
    944,
    947,
    950,
    953,
    956,
    959,
    966,
    971,
    975,
    979,
    982,
    985,
    988,
    992,
    996,
    999,
    1002,
    1006,
    1009,
    1012,
    1015,
    1018,
    1022,
    1025,
    1028,
    1031,
    1034,
    1037,
    1040,
    1043,
    1046,
    1049,
    1052,
    1057,
    1060,
    1063,
    1066,
    1069,
    1072,
    1075,
    1078,
    1081,
    1084,
    1087,
    1090,
    1093,
    1096,
    1099,
    1102,
    1106,
    1109,
    1112,
    1115,
    1118,
    1123,
    1130,
    1133,
    1136,
    1139,
    1142,
    1145,
    1148,
    1151,
    1156,
    1159,
    1165,
    1168,
    1171,
    1174,
    1177,
    1180,
    1183,
    1192,
    1195,
    1198,
    1201,
    1204,
    1207,
    1210,
    1213,
    1217,
    1220,
    1223,
    1226,
    1229,
    1232,
    1235,
    1238,
    1240,
    1243,
    1246,
    1249,
    1252,
    1255,
    1258,
    1262,
    1265,
    1271,
    1274,
    1277,
    1283,
    1289,
    1298,
    1301,
    1308,
    1311,
    1314,
    1317,
    1320,
    1323,
    1326,
    1329,
    1334,
    1337,
    1340,
    1343,
    1346,
    1348,
    1351,
    1354,
    1357,
    1363,
    1366,
    1369,
    1372,
    1376,
    1379,
    1382,
    1385,
    1388,
    1391,
    1394,
    1397,
    1401,
    1404,
    1407,
    1410,
    1413,
    1417,
    1420,
    1424,
    1427,
    1430,
    1433,
    1439,
    1442,
    1445,
    1448,
    1451,
    1454,
    1457,
    1463,
    1466,
    1469,
    1472,
    1475,
    1479,
    1482,
    1485,
    1488,
    1491,
    1494,
    1497,
    1500,
    1530,
    1533,
    1536,
    1539,
    1542,
    1545,
    1550,
    1553,
    1556,
    1559,
    1562,
    1565,
    1571,
    1574,
    1577,
    1580,
    1583,
    1586,
    1591,
    1594,
    1597,
    1600,
    1604,
    1607,
    1610,
    1613,
    1619,
    1622,
    1626,
    1630,
    1633,
    1636,
    1639,
    1642,
    1645,
    1648,
    1651,
    1654,
    1657,
    1660,
    1663,
    1666,
    1669,
    1672,
    1676,
    1679,
    1682,
    1685,
    1688,
    1691,
    1694,
    1697,
    1700,
    1710,
    1713,
    1716,
    1721,
    1724,
    1727,
    1730,
    1733,
    1736,
    1739,
    1742,
    1745,
    1749,
    1752,
    1755,
    1758,
    1761,
    1764,
    1767,
    1770,
    1777,
    1780,
    1783,
    1786,
    1792,
    1795,
    1798,
    1801,
    1804,
    1807,
    1815,
    1818,
    1821,
    1824,
    1827,
    1830,
    1833,
    1836,
    1839,
    1848,
    1851,
    1854,
    1857,
    1863,
    1866,
    1869,
    1872,
    1875,
    1878,
    1882,
    1885,
    1888,
    1891,
    1894,
    1897,
    1902,
    1905,
    1909,
    1912,
    1915,
    1920,
    1923,
    1926,
    1929,
    1932,
    1935,
    1938,
    1941,
    1944,
    1947,
    1950,
    1953,
    1956,
    1959,
    1962,
    1965,
    1968,
    1971,
    2150, 
]);
/** Chuyên mục WordPress lạc đề: Bất Động Sản (5), Công Nghệ (8), Du Lịch (4).
 *  Bài MỚI đăng vào các chuyên mục này tự noindex, trừ khi tiêu đề nhắc tới trang sức/An Thư. */ var OFF_TOPIC_CATEGORY_IDS = [
    5,
    8,
    4
];
var JEWELRY_KEYWORDS = /kim cương|trang sức|an thư|anthu|nhẫn|bông tai|dây chuyền|đá quý|ngọc trai/i;
var isArticleNoindex = function(post) {
    var ref, ref1, ref2;
    if (!post) return false;
    if ((post === null || post === void 0 ? void 0 : (ref = post.yoast_head_json) === null || ref === void 0 ? void 0 : (ref1 = ref.robots) === null || ref1 === void 0 ? void 0 : ref1.index) === "noindex") return true;
    if (OFF_TOPIC_ARTICLE_IDS.has(Number(post.id))) return true;
    var cats = Array.isArray(post.categories) ? post.categories : [];
    var title = (post === null || post === void 0 ? void 0 : (ref2 = post.title) === null || ref2 === void 0 ? void 0 : ref2.rendered) || "";
    return cats.length > 0 && cats.every(function(c) {
        return OFF_TOPIC_CATEGORY_IDS.includes(c);
    }) && !JEWELRY_KEYWORDS.test(title);
};


/***/ }),

/***/ 65055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RelatedProduct; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(13390);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./libs/app/index.ts + 40 modules
var app = __webpack_require__(41255);
// EXTERNAL MODULE: ./components/ui/Image/index.tsx
var Image = __webpack_require__(81703);
// EXTERNAL MODULE: ./components/icons/Pentagon/index.tsx
var Pentagon = __webpack_require__(92172);
// EXTERNAL MODULE: ./components/ui/Link/index.tsx
var Link = __webpack_require__(43701);
// EXTERNAL MODULE: ./components/ui/NewGallery/index.tsx
var NewGallery = __webpack_require__(23303);
;// CONCATENATED MODULE: ./features/article/partial/ProductLoop.tsx






var ProductLoop = function(props) {
    var ref, ref1, ref2;
    var p = props.p, t = props.t;
    var handle = "".concat((0,app/* createHandle */.UR)(p.product_name), "-").concat(p.id, "-").concat(p.product_code);
    var isDiscount = p.product_discount ? (0,app/* checkTime */.s)((ref = p.product_discount) === null || ref === void 0 ? void 0 : ref.started_at, (ref1 = p.product_discount) === null || ref1 === void 0 ? void 0 : ref1.ended_at) : false;
    if (p.product_discount && ((ref2 = p.product_discount) === null || ref2 === void 0 ? void 0 : ref2.status) === shared/* DiscountStatus.Ended */.YT.Ended) isDiscount = false;
    var isDeposited = p.quantity <= 0 || p.status == shared/* ProductStatus.CloseASale */.Pt.CloseASale || p.status === shared/* ProductStatus.Deposited */.Pt.Deposited;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full tw-h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-rounded-5 tw-border tw-border-gray-70 tw-overflow-hidden tw-w-full tw-h-full hover:tw-border-primary-main tw-duration-500 tw-ease-linear",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-w-full p-100p tw-relative tw-leading-0 tw-h-0 tw-bg-secondary-20",
                    children: [
                        p.images && p.images.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewGallery/* default */.Z, {
                                images: p.images
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            className: "tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0",
                            alt: p.product_name,
                            src: p.images && p.images[0] ? p.images[0].url : ""
                        }),
                        p.product_discount && isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-7 tw-h-7 tw-absolute tw-top-3 tw-right-3 tw-z-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    src: "/sale.png",
                                    className: "tw-w-full tw-h-full",
                                    alt: "sale"
                                })
                            })
                        }),
                        isDeposited && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-absolute tw-z-10",
                            style: {
                                top: "8px",
                                left: "0"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pentagon/* PentagonIcon */.n, {
                                    text: t("detail.label.soldOut")
                                }),
                                " "
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-pt-4 tw-pb-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            url: {
                                pathname: shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                                query: {
                                    id: handle
                                }
                            },
                            className: "tw-h-12 md:tw-h-12 tw-px-1 tw-text-base tw-font-semibold tw-text-primary-main tw-w-full tw-line-clamp-2 tw-text-center",
                            children: p.product_name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-secondary-81 tw-font-light tw-text-sm md:tw-text-base tw-line-clamp-1 tw-px-1",
                                    children: p.product_code
                                }),
                                p.quotation ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-text-secondary-70",
                                    children: t("product:detail.label.contact")
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: p.product_discount && isDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                            children: (0,app/* toMoney */.KP)(p.price - p.price * p.product_discount.discount / 100, t, shared/* PriceSymbol.$ */.hb.$)
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                            children: (0,app/* toMoney */.KP)(p.price, t, shared/* PriceSymbol.$ */.hb.$)
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./features/article/partial/RelatedProduct.tsx








var NewProduct = function(param) {
    var products = param.products, t = param.t;
    var LENGTH = products.length;
    var ref = (0,react.useState)([
        0,
        1,
        2
    ]), indexShow = ref[0], setIndexShow = ref[1];
    var ref1 = (0,react.useState)(false), nextDisable = ref1[0], setNextDisable = ref1[1];
    var ref2 = (0,react.useState)(true), previewDisable = ref2[0], setPreviewDisable = ref2[1];
    var next = function() {
        var _Math;
        var max = (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(indexShow));
        if (max === LENGTH - 1) {
            return setNextDisable(true);
        }
        if (max < LENGTH - 1) {
            setIndexShow([
                indexShow[1],
                indexShow[2],
                max + 1
            ]);
            setPreviewDisable(false);
        }
    };
    var preview = function() {
        var _Math;
        var min = (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(indexShow));
        if (min === 0) {
            return setPreviewDisable(true);
        }
        if (min > 0) {
            setIndexShow([
                min - 1,
                indexShow[0],
                indexShow[1]
            ]);
            setNextDisable(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-items-center tw-w-full tw-relative after:tw-absolute after:tw-right-0 after:tw-top-1/2 after:tw-h-[1px] after:tw-bg-primary-main/[0.5] before:tw-left-0 before:tw-top-1/2 before:tw-h-[1px] before:tw-bg-primary-main/[0.5] xl:after:tw-w-[300px] xl:before:tw-w-[300px] lg:before:tw-w-[240px] lg:after:tw-w-[240px] md:before:tw-w-[140px] md:after:tw-w-[140px] [425px]:before:tw-w-[30px] before:tw-w-[10px] after:tw-w-[10px] [425px]:after:tw-w-[30px] 2xl:after:tw-w-[400px] 2xl:before:tw-w-[400px] tw-h-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-x-2 md:tw-gap-x-4 tw-px-2 md:tw-px-5 tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-max-w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: "/diamond.svg",
                            alt: "star",
                            className: "tw-h-5 tw-w-5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-inline-block tw-text-base md:tw-text-2xl tw-uppercase tw-font-semibold tw-w-max tw-text-primary-main",
                            children: "C\xe1c sản phẩm li\xean quan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: "/diamond.svg",
                            alt: "star",
                            className: "tw-h-5 tw-w-5"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-w-max tw-mx-auto tw-mt-10",
                children: products.length > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-absolute tw-top-1/2 tw--translate-y-1/2 tw--left-6 md:tw--left-10",
                            children: previewDisable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-opacity-70",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    className: "tw-w-6 tw-h-6 md:tw-h-10 md:tw-w-10",
                                    alt: "left",
                                    src: "/left-light.svg"
                                })
                            }, "pre-disable") : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: preview,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    className: "tw-w-6 tw-h-6 md:tw-h-10 md:tw-w-10 tw-cursor-pointer",
                                    alt: "left",
                                    src: "/left-light.svg"
                                })
                            }, "pre")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-flex tw-justify-center tw-w-full",
                            children: products.map(function(p, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(indexShow.includes(index) ? "tw-block tw-px-2 tw-duration-400" : "tw-hidden", " tw-w-[248px]"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLoop, {
                                        p: p,
                                        t: t
                                    })
                                }, p.cat_code);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-absolute tw-top-1/2 tw--translate-y-1/2 tw--right-6 md:tw--right-10",
                            children: nextDisable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-opacity-70",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    className: "tw-w-6 tw-h-6 md:tw-h-10 md:tw-w-10",
                                    alt: "right",
                                    src: "/right-light.svg"
                                })
                            }, "next-disabled") : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: next,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    className: "tw-w-6 tw-h-6 md:tw-h-10 md:tw-w-10 tw-cursor-pointer",
                                    alt: "right",
                                    src: "/right-light.svg"
                                })
                            }, "next")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-w-full tw-flex tw-gap-4 tw-justify-center",
                    children: products.map(function(p, key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-[248px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLoop, {
                                p: p,
                                t: t
                            })
                        }, "item-".concat(key));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var RelatedProduct = (/*#__PURE__*/(0,react.memo)(NewProduct));


/***/ }),

/***/ 99101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ambassador_registration_AmbassadorRegistrationForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/form/TextField/index.tsx
var TextField = __webpack_require__(40717);
// EXTERNAL MODULE: ./components/ui/Icon/index.tsx
var Icon = __webpack_require__(58262);
// EXTERNAL MODULE: ./components/icons/User/index.tsx
var User = __webpack_require__(94423);
// EXTERNAL MODULE: ./components/ui/Input/index.tsx
var Input = __webpack_require__(19747);
// EXTERNAL MODULE: ./components/icons/Phone/index.tsx
var Phone = __webpack_require__(53196);
// EXTERNAL MODULE: ./components/ui/Link/index.tsx
var Link = __webpack_require__(43701);
// EXTERNAL MODULE: ./components/ui/Button/index.tsx
var Button = __webpack_require__(73055);
// EXTERNAL MODULE: ./components/ui/ModalCustom/index.tsx
var ModalCustom = __webpack_require__(8101);
// EXTERNAL MODULE: ./components/ui/ModalHeader/index.tsx
var ModalHeader = __webpack_require__(7178);
// EXTERNAL MODULE: ./components/ui/ModalBody/index.tsx
var ModalBody = __webpack_require__(52604);
// EXTERNAL MODULE: ./components/ui/ModalFooter/index.tsx
var ModalFooter = __webpack_require__(65813);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 25 modules
var esm = __webpack_require__(10268);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./libs/axios/index.ts
var axios = __webpack_require__(80787);
;// CONCATENATED MODULE: ./features/article/partial/ambassador-registration/api.ts


var signUpAmbassador = function(payload) {
    return axios/* default.post */.ZP.post("/api/v1/user/ambassador/register", payload);
};
var useSignUpAmbassadorQuery = function(options) {
    return (0,react_query_es.useMutation)(function(payload) {
        return signUpAmbassador(payload);
    }, options);
};

// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(74931);
// EXTERNAL MODULE: ./contexts/profile/index.tsx
var profile = __webpack_require__(48309);
;// CONCATENATED MODULE: ./features/article/partial/ambassador-registration/AmbassadorRegistrationForm.tsx












var AmbassadorRegistrationForm = function(props) {
    var ref, ref1;
    var article = props.article;
    var t = (0,esm/* useTranslation */.$G)([
        "layout"
    ]).t;
    var masterData = (0,profile/* useMasterData */.AE)();
    var ambassador_info = masterData === null || masterData === void 0 ? void 0 : masterData.ambassador_info;
    var ref2 = (0,react.useState)(false), isShowSuccessMsg = ref2[0], setIsShowSuccessMsg = ref2[1];
    var ref3 = (0,react.useState)(false), isShowForm = ref3[0], setIsShowForm = ref3[1];
    (0,react.useEffect)(function() {
        var getSlugFromUrl = function(url) {
            if (!url) return "";
            var parts = url.split("/").filter(function(el) {
                return !!el;
            });
            return parts[parts.length - 1];
        };
        var slug = getSlugFromUrl(ambassador_info === null || ambassador_info === void 0 ? void 0 : ambassador_info.url);
        setIsShowForm(slug === article.slug);
    }, [
        article === null || article === void 0 ? void 0 : article.slug,
        ambassador_info === null || ambassador_info === void 0 ? void 0 : ambassador_info.url
    ]);
    var ref4 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            phone: "",
            fullname: ""
        },
        resolver: (0,yup_module/* yupResolver */.X)(es/* object */.Ry({
            phone: es/* string */.Z_().required(t("ambassador-register.message.phone-required")),
            fullname: es/* string */.Z_().required(t("ambassador-register.message.fullname-required"))
        }))
    }), control = ref4.control, handleSubmit = ref4.handleSubmit, errors = ref4.formState.errors;
    var ref5 = useSignUpAmbassadorQuery({
        onSuccess: function() {
            setIsShowSuccessMsg(true);
        },
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        }
    }), mutate = ref5.mutate, isLoading = ref5.isLoading;
    var onSubmit = handleSubmit(function(data) {
        mutate((0,_object_spread/* default */.Z)({}, data));
    });
    var keyPress = function(e) {
        if (e.keyCode === 13) {
            onSubmit();
        }
    };
    if (!isShowForm) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-w-full sm:tw-w-[440px] tw-mx-auto tw-mt-6 tw-px-2 lg:tw-p-4 tw-rounded-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "tw-text-center tw-text-xl tw-font-semibold",
                        children: t("ambassador-register.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-mt-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* TextField */.n, {
                                name: "fullname",
                                control: control,
                                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(User/* UserOutlineIcon */.V, {
                                        className: "tw-text-primary-main"
                                    })
                                }),
                                variant: Input/* InputVariant.Outlined */.J.Outlined,
                                error: (ref = errors.fullname) === null || ref === void 0 ? void 0 : ref.message,
                                containerClassName: "tw-h-[50px] tw-px-4 tw-rounded-lg",
                                errorMessageClassName: "tw-px-4",
                                placeholder: t("ambassador-register.form.label.fullname"),
                                onKeyDown: keyPress
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* TextField */.n, {
                                name: "phone",
                                control: control,
                                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone/* PhoneIcon */.q, {
                                        className: "tw-text-primary-main"
                                    })
                                }),
                                variant: Input/* InputVariant.Outlined */.J.Outlined,
                                error: (ref1 = errors.phone) === null || ref1 === void 0 ? void 0 : ref1.message,
                                containerClassName: "tw-h-[50px] tw-px-4 tw-rounded-lg tw-mt-6",
                                errorMessageClassName: "tw-px-4",
                                placeholder: t("ambassador-register.form.label.phone"),
                                onKeyDown: keyPress
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-mt-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                    t: t,
                                    i18nKey: "ambassador-register.label.policies",
                                    components: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            url: {
                                                pathname: shared/* PagePath.PrivacyPolicyPage */._.PrivacyPolicyPage
                                            }
                                        }, "ambassador-register.label.policies"), 
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                loading: isLoading,
                                onClick: onSubmit,
                                className: "tw-mt-4 tw-h-[50px] tw-rounded-lg",
                                children: t("ambassador-register.btn.submit")
                            })
                        ]
                    })
                ]
            }),
            isShowSuccessMsg && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalCustom/* ModalCustom */.w, {
                className: "tw-w-[360px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeader/* ModalHeader */.x, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-font-bold tw-text-lg tw-text-center",
                            children: t("ambassador-register.modal.register-success-title")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody/* ModalBody */.f, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tw-text-center",
                            children: t("ambassador-register.modal.register-success-description")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFooter/* ModalFooter */.m, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-flex tw-justify-end tw-gap-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                variant: Button/* ButtonVariant.Outlined */.W.Outlined,
                                className: "tw-text-primary-main tw-font-bold",
                                onClick: function() {
                                    return setIsShowSuccessMsg(false);
                                },
                                children: "OK"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ambassador_registration_AmbassadorRegistrationForm = (AmbassadorRegistrationForm);


/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 13390:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 16573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_assert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25456);
/* harmony import */ var _utils_objectToGetParams__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86459);
/* harmony import */ var _hocs_createShareButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79075);



function facebookLink(url, _a) {
    var quote = _a.quote, hashtag = _a.hashtag;
    (0,_utils_assert__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(url, 'facebook.url');
    return ('https://www.facebook.com/sharer/sharer.php' +
        (0,_utils_objectToGetParams__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            u: url,
            quote: quote,
            hashtag: hashtag,
        }));
}
var FacebookShareButton = (0,_hocs_createShareButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('facebook', facebookLink, function (props) { return ({
    quote: props.quote,
    hashtag: props.hashtag,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ __webpack_exports__["Z"] = (FacebookShareButton);


/***/ }),

/***/ 79075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hocs_createShareButton; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-share/node_modules/classnames/index.js
var classnames = __webpack_require__(97567);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/react-share/es/ShareButton.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var isPromise = function (obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};
var getBoxPositionOnWindowCenter = function (width, height) { return ({
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
}); };
var getBoxPositionOnScreenCenter = function (width, height) { return ({
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2,
}); };
function windowOpen(url, _a, onClose) {
    var height = _a.height, width = _a.width, configRest = __rest(_a, ["height", "width"]);
    var config = __assign({ height: height, width: width, location: 'no', toolbar: 'no', status: 'no', directories: 'no', menubar: 'no', scrollbars: 'yes', resizable: 'no', centerscreen: 'yes', chrome: 'yes' }, configRest);
    var shareDialog = window.open(url, '', Object.keys(config)
        .map(function (key) { return "".concat(key, "=").concat(config[key]); })
        .join(', '));
    if (onClose) {
        var interval_1 = window.setInterval(function () {
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval_1);
                    onClose(shareDialog);
                }
            }
            catch (e) {
                /* eslint-disable no-console */
                console.error(e);
                /* eslint-enable no-console */
            }
        }, 1000);
    }
    return shareDialog;
}
var ShareButton = /** @class */ (function (_super) {
    __extends(ShareButton, _super);
    function ShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openShareDialog = function (link) {
            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? 'windowCenter' : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
            var windowConfig = __assign({ height: windowHeight, width: windowWidth }, (windowPosition === 'windowCenter'
                ? getBoxPositionOnWindowCenter(windowWidth, windowHeight)
                : getBoxPositionOnScreenCenter(windowWidth, windowHeight)));
            windowOpen(link, windowConfig, onShareWindowClose);
        };
        _this.handleClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
                        link = networkLink(url, opts);
                        if (disabled) {
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        if (!beforeOnClick) return [3 /*break*/, 2];
                        returnVal = beforeOnClick();
                        if (!isPromise(returnVal)) return [3 /*break*/, 2];
                        return [4 /*yield*/, returnVal];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (openShareDialogOnClick) {
                            this.openShareDialog(link);
                        }
                        if (onClick) {
                            onClick(event, link);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ShareButton.prototype.render = function () {
        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = __rest(_a, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]);
        var newClassName = classnames_default()('react-share__ShareButton', {
            'react-share__ShareButton--disabled': !!disabled,
            disabled: !!disabled,
        }, className);
        var newStyle = resetButtonStyle
            ? __assign(__assign({ backgroundColor: 'transparent', border: 'none', padding: 0, font: 'inherit', color: 'inherit', cursor: 'pointer' }, style), (disabled && disabledStyle)) : __assign(__assign({}, style), (disabled && disabledStyle));
        return (react.createElement("button", __assign({}, rest, { "aria-label": rest['aria-label'] || networkName, className: newClassName, onClick: this.handleClick, ref: forwardedRef, style: newStyle }), children));
    };
    ShareButton.defaultProps = {
        disabledStyle: { opacity: 0.6 },
        openShareDialogOnClick: true,
        resetButtonStyle: true,
    };
    return ShareButton;
}(react.Component));
/* harmony default export */ var es_ShareButton = (ShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/hocs/createShareButton.js
var createShareButton_assign = (undefined && undefined.__assign) || function () {
    createShareButton_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return createShareButton_assign.apply(this, arguments);
};


function createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        var opts = optsMap(props);
        var passedProps = createShareButton_assign({}, props);
        // remove keys from passed props that are passed as opts
        var optsKeys = Object.keys(opts);
        optsKeys.forEach(function (key) {
            delete passedProps[key];
        });
        return (react.createElement(es_ShareButton, createShareButton_assign({}, defaultProps, passedProps, { forwardedRef: ref, networkName: networkName, networkLink: link, opts: optsMap(props) })));
    }
    CreatedButton.displayName = "ShareButton-".concat(networkName);
    return (0,react.forwardRef)(CreatedButton);
}
/* harmony default export */ var hocs_createShareButton = (createShareButton);


/***/ }),

/***/ 25456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ assert; }
/* harmony export */ });
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'AssertionError';
        return _this;
    }
    return AssertionError;
}(Error));
function assert(value, message) {
    if (!value) {
        throw new AssertionError(message);
    }
}


/***/ }),

/***/ 86459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ objectToGetParams; }
/* harmony export */ });
function objectToGetParams(object) {
    var params = Object.entries(object)
        .filter(function (_a) {
        var value = _a[1];
        return value !== undefined && value !== null;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    });
    return params.length > 0 ? "?".concat(params.join('&')) : '';
}


/***/ }),

/***/ 97567:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

}]);